import { useState } from "react";
import { ArrowRight, Share2 } from "lucide-react";
import Compartilhar from "./compartilhar";

export default function CardArtigoLg({img, tag, title, summary, date, link, isMobile}){

    const [toggleCompartilhar, setToggleCompartilhar] = useState(false)
    const newLink = window.location.toString().replace('blog', '') + link.slice(1)
    return !isMobile ? (
        <div className=" max-w-[1181px] h-[416px] flex flex-row gap-6 flex-1">
            {toggleCompartilhar ? <Compartilhar toggle={setToggleCompartilhar} link={newLink}/> : false}
            <div className=" w-[600px] min-w-[550px] h-[416px] overflow-hidden rounded-lg">
                <img  src={img}></img>
            </div>
                       
            <div className="min-w-[200px] h-[416px] w-full flex flex-col justify-between">
                <div>
                    <div className="flex flex-row gap-5 ">
                        <h2 className=" font-roboto text-xs text-[#333333] font-bold uppercase" >{tag}</h2>
                        <p className=" font-roboto text-xs text-[#959494] font-medium" >{date}</p>
                    </div>

                    <h1 className=" font-raleway_bold text-[#333333] text-4xl font-semibold mt-6">{title}</h1>
                    <p className=" text-wrap mt-10 text-[#666666] font-roboto text-base font-normal">{summary}</p>
                </div>
                <div className=" flex flex-row gap-4 align-middle">
                    <a className="text-[#2D2E80] font-roboto text-base font-normal underline" href={link}>Ler mais</a>
                    <img src="../assets/seta.png" className="w-fit h-fit self-center"/>
                    <img onClick={()=>{setToggleCompartilhar(true)}} src="../assets/compartilhar_icon.png" className="w-fit h-fit self-center ml-6"/>
                </div>
            </div>

        </div>
    ) : (
        <div className="px-6 py-4 gap-2 active:bg-[#F6F6F6]">
            {toggleCompartilhar && <Compartilhar toggle={setToggleCompartilhar} link={newLink}/>} 
            <div className="relative">
                <a href={link} className="block">
                    <div className="flex pt-2 ">
                        <div className="w-1/2 pr-2">
                            <div className="h-[137px] w-full overflow-hidden rounded-lg">
                                <img src={img} className="h-full w-full object-cover" alt="Imagem" />
                            </div>
                        </div>
                        <div className="w-1/2 pl-2 flex flex-col justify-between">                
                            <div>
                                <div className="flex flex-col">
                                    <h2 className="font-roboto text-[8px] text-[#333333] font-bold uppercase">{tag}</h2>
                                    <p className="font-roboto text-[8px] text-[#959494] font-medium">{date}</p>
                                </div>
                                <h1 className="font-raleway_bold text-[#333333] text-[15px] mt-2">
                                    {title.split(' ').slice(0, 8).join(' ')}...
                                </h1>
                            </div>
                            <div className=" flex flex-row gap-4 align-middle">
                                <p className="text-[#2D2E80] font-roboto text-xs">Ler mais</p>
                                <ArrowRight size={16} color="#2D2E80" className="self-center"/>
                            </div>
                        </div>
                    </div>
                </a>
                <div className="absolute bottom-0 right-10 flex gap-2">
                    <button onClick={(e) => { setToggleCompartilhar(true); }}>
                        <Share2 size={16} color="#2D2E80" className="self-center ml-2 cursor-pointer" />
                    </button>
                </div>
            </div>
        </div>
    )
}